import React from "react";
import {Route} from "react-router-dom";
import {withAuthenticationRequired} from "@auth0/auth0-react";

const PrivateRoute = ({component, ...args}) => (
    <Route
        component={withAuthenticationRequired(component, {
            onRedirecting: () => <div>Redirecting to login page...</div>,
        })}
        {...args}
    />
);

export default PrivateRoute;